/*!
 * Copyright (c) 2022 Salesforce.org LLC
 * All rights reserved.
 */

!(function (t, e) {
  if (window) {
    window.ElevateDonationWidgetSDK = e();
  }

  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : ((t =
        "undefined" != typeof globalThis
          ? globalThis
          : t || self).ElevateDonationWidgetSDK = e());
})(this, function () {
  "use strict";
  function t() {
    for (var t = 0, e = 0, n = arguments.length; e < n; e++)
      t += arguments[e].length;
    var r = Array(t),
      o = 0;
    for (e = 0; e < n; e++)
      for (var i = arguments[e], a = 0, u = i.length; a < u; a++, o++)
        r[o] = i[a];
    return r;
  }
  var e = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    },
    n = {}.toString,
    r = function (t) {
      return n.call(t).slice(8, -1);
    },
    o = "".split,
    i = e(function () {
      return !Object("z").propertyIsEnumerable(0);
    })
      ? function (t) {
          return "String" == r(t) ? o.call(t, "") : Object(t);
        }
      : Object,
    a = function (t) {
      if (null == t) throw TypeError("Can't call method on " + t);
      return t;
    },
    u = function (t) {
      return i(a(t));
    },
    c =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : {};
  function f(t, e, n) {
    return (
      t(
        (n = {
          path: e,
          exports: {},
          require: function (t, e) {
            return (function () {
              throw new Error(
                "Dynamic requires are not currently supported by @rollup/plugin-commonjs"
              );
            })(null == e && n.path);
          },
        }),
        n.exports
      ),
      n.exports
    );
  }
  var s,
    l = function (t) {
      return t && t.Math == Math && t;
    },
    p =
      l("object" == typeof globalThis && globalThis) ||
      l("object" == typeof window && window) ||
      l("object" == typeof self && self) ||
      l("object" == typeof c && c) ||
      (function () {
        return this;
      })() ||
      Function("return this")(),
    h = !e(function () {
      return (
        7 !=
        Object.defineProperty({}, 1, {
          get: function () {
            return 7;
          },
        })[1]
      );
    }),
    g = function (t) {
      return "object" == typeof t ? null !== t : "function" == typeof t;
    },
    y = p.document,
    d = g(y) && g(y.createElement),
    v = function (t) {
      return d ? y.createElement(t) : {};
    },
    m =
      !h &&
      !e(function () {
        return (
          7 !=
          Object.defineProperty(v("div"), "a", {
            get: function () {
              return 7;
            },
          }).a
        );
      }),
    E = function (t) {
      if (!g(t)) throw TypeError(String(t) + " is not an object");
      return t;
    },
    b = function (t, e) {
      if (!g(t)) return t;
      var n, r;
      if (e && "function" == typeof (n = t.toString) && !g((r = n.call(t))))
        return r;
      if ("function" == typeof (n = t.valueOf) && !g((r = n.call(t)))) return r;
      if (!e && "function" == typeof (n = t.toString) && !g((r = n.call(t))))
        return r;
      throw TypeError("Can't convert object to primitive value");
    },
    S = Object.defineProperty,
    _ = {
      f: h
        ? S
        : function (t, e, n) {
            if ((E(t), (e = b(e, !0)), E(n), m))
              try {
                return S(t, e, n);
              } catch (t) {}
            if ("get" in n || "set" in n)
              throw TypeError("Accessors not supported");
            return "value" in n && (t[e] = n.value), t;
          },
    },
    w = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e,
      };
    },
    O = h
      ? function (t, e, n) {
          return _.f(t, e, w(1, n));
        }
      : function (t, e, n) {
          return (t[e] = n), t;
        },
    I = function (t, e) {
      try {
        O(p, t, e);
      } catch (n) {
        p[t] = e;
      }
      return e;
    },
    R = "__core-js_shared__",
    P = p[R] || I(R, {}),
    N = f(function (t) {
      (t.exports = function (t, e) {
        return P[t] || (P[t] = void 0 !== e ? e : {});
      })("versions", []).push({
        version: "3.8.0",
        mode: "global",
        copyright: "Â© 2020 Denis Pushkarev (zloirock.ru)",
      });
    }),
    x = {}.hasOwnProperty,
    U = function (t, e) {
      return x.call(t, e);
    },
    T = 0,
    j = Math.random(),
    L = function (t) {
      return (
        "Symbol(" +
        String(void 0 === t ? "" : t) +
        ")_" +
        (++T + j).toString(36)
      );
    },
    G =
      !!Object.getOwnPropertySymbols &&
      !e(function () {
        return !String(Symbol());
      }),
    D = G && !Symbol.sham && "symbol" == typeof Symbol.iterator,
    k = N("wks"),
    A = p.Symbol,
    M = D ? A : (A && A.withoutSetter) || L,
    F = function (t) {
      return (
        U(k, t) || (G && U(A, t) ? (k[t] = A[t]) : (k[t] = M("Symbol." + t))),
        k[t]
      );
    },
    C = Math.ceil,
    V = Math.floor,
    B = function (t) {
      return isNaN((t = +t)) ? 0 : (t > 0 ? V : C)(t);
    },
    z = Math.min,
    q = Math.max,
    W = Math.min,
    H = function (t) {
      return function (e, n, r) {
        var o,
          i,
          a = u(e),
          c = (o = a.length) > 0 ? z(B(o), 9007199254740991) : 0,
          f = (function (t, e) {
            var n = B(t);
            return n < 0 ? q(n + e, 0) : W(n, e);
          })(r, c);
        if (t && n != n) {
          for (; c > f; ) if ((i = a[f++]) != i) return !0;
        } else
          for (; c > f; f++)
            if ((t || f in a) && a[f] === n) return t || f || 0;
        return !t && -1;
      };
    },
    J = { includes: H(!0), indexOf: H(!1) },
    X = {},
    K = J.indexOf,
    Y = function (t, e) {
      var n,
        r = u(t),
        o = 0,
        i = [];
      for (n in r) !U(X, n) && U(r, n) && i.push(n);
      for (; e.length > o; ) U(r, (n = e[o++])) && (~K(i, n) || i.push(n));
      return i;
    },
    Z = [
      "constructor",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "toLocaleString",
      "toString",
      "valueOf",
    ],
    Q =
      Object.keys ||
      function (t) {
        return Y(t, Z);
      },
    $ = h
      ? Object.defineProperties
      : function (t, e) {
          E(t);
          for (var n, r = Q(e), o = r.length, i = 0; o > i; )
            _.f(t, (n = r[i++]), e[n]);
          return t;
        },
    tt = p,
    et = function (t) {
      return "function" == typeof t ? t : void 0;
    },
    nt = function (t, e) {
      return arguments.length < 2
        ? et(tt[t]) || et(p[t])
        : (tt[t] && tt[t][e]) || (p[t] && p[t][e]);
    },
    rt = nt("document", "documentElement"),
    ot = N("keys"),
    it = function (t) {
      return ot[t] || (ot[t] = L(t));
    },
    at = it("IE_PROTO"),
    ut = function () {},
    ct = function (t) {
      return "<script>" + t + "</" + "script>";
    },
    ft = function () {
      try {
        s = document.domain && new ActiveXObject("htmlfile");
      } catch (t) {}
      var t, e;
      ft = s
        ? (function (t) {
            t.write(ct("")), t.close();
            var e = t.parentWindow.Object;
            return (t = null), e;
          })(s)
        : (((e = v("iframe")).style.display = "none"),
          rt.appendChild(e),
          (e.src = String("javascript:")),
          (t = e.contentWindow.document).open(),
          t.write(ct("document.F=Object")),
          t.close(),
          t.F);
      for (var n = Z.length; n--; ) delete ft.prototype[Z[n]];
      return ft();
    };
  X[at] = !0;
  var st =
      Object.create ||
      function (t, e) {
        var n;
        return (
          null !== t
            ? ((ut.prototype = E(t)),
              (n = new ut()),
              (ut.prototype = null),
              (n[at] = t))
            : (n = ft()),
          void 0 === e ? n : $(n, e)
        );
      },
    lt = F("unscopables"),
    pt = Array.prototype;
  null == pt[lt] && _.f(pt, lt, { configurable: !0, value: st(null) });
  var ht = function (t) {
      pt[lt][t] = !0;
    },
    gt = {},
    yt = Function.toString;
  "function" != typeof P.inspectSource &&
    (P.inspectSource = function (t) {
      return yt.call(t);
    });
  var dt,
    vt,
    mt,
    Et = P.inspectSource,
    bt = p.WeakMap,
    St = "function" == typeof bt && /native code/.test(Et(bt)),
    _t = p.WeakMap;
  if (St) {
    var wt = P.state || (P.state = new _t()),
      Ot = wt.get,
      It = wt.has,
      Rt = wt.set;
    (dt = function (t, e) {
      return (e.facade = t), Rt.call(wt, t, e), e;
    }),
      (vt = function (t) {
        return Ot.call(wt, t) || {};
      }),
      (mt = function (t) {
        return It.call(wt, t);
      });
  } else {
    var Pt = it("state");
    (X[Pt] = !0),
      (dt = function (t, e) {
        return (e.facade = t), O(t, Pt, e), e;
      }),
      (vt = function (t) {
        return U(t, Pt) ? t[Pt] : {};
      }),
      (mt = function (t) {
        return U(t, Pt);
      });
  }
  var Nt,
    xt,
    Ut,
    Tt = {
      set: dt,
      get: vt,
      has: mt,
      enforce: function (t) {
        return mt(t) ? vt(t) : dt(t, {});
      },
      getterFor: function (t) {
        return function (e) {
          var n;
          if (!g(e) || (n = vt(e)).type !== t)
            throw TypeError("Incompatible receiver, " + t + " required");
          return n;
        };
      },
    },
    jt = {}.propertyIsEnumerable,
    Lt = Object.getOwnPropertyDescriptor,
    Gt = {
      f:
        Lt && !jt.call({ 1: 2 }, 1)
          ? function (t) {
              var e = Lt(this, t);
              return !!e && e.enumerable;
            }
          : jt,
    },
    Dt = Object.getOwnPropertyDescriptor,
    kt = {
      f: h
        ? Dt
        : function (t, e) {
            if (((t = u(t)), (e = b(e, !0)), m))
              try {
                return Dt(t, e);
              } catch (t) {}
            if (U(t, e)) return w(!Gt.f.call(t, e), t[e]);
          },
    },
    At = f(function (t) {
      var e = Tt.get,
        n = Tt.enforce,
        r = String(String).split("String");
      (t.exports = function (t, e, o, i) {
        var a,
          u = !!i && !!i.unsafe,
          c = !!i && !!i.enumerable,
          f = !!i && !!i.noTargetGet;
        "function" == typeof o &&
          ("string" != typeof e || U(o, "name") || O(o, "name", e),
          (a = n(o)).source ||
            (a.source = r.join("string" == typeof e ? e : ""))),
          t !== p
            ? (u ? !f && t[e] && (c = !0) : delete t[e],
              c ? (t[e] = o) : O(t, e, o))
            : c
            ? (t[e] = o)
            : I(e, o);
      })(Function.prototype, "toString", function () {
        return ("function" == typeof this && e(this).source) || Et(this);
      });
    }),
    Mt = Z.concat("length", "prototype"),
    Ft = {
      f:
        Object.getOwnPropertyNames ||
        function (t) {
          return Y(t, Mt);
        },
    },
    Ct = { f: Object.getOwnPropertySymbols },
    Vt =
      nt("Reflect", "ownKeys") ||
      function (t) {
        var e = Ft.f(E(t)),
          n = Ct.f;
        return n ? e.concat(n(t)) : e;
      },
    Bt = function (t, e) {
      for (var n = Vt(e), r = _.f, o = kt.f, i = 0; i < n.length; i++) {
        var a = n[i];
        U(t, a) || r(t, a, o(e, a));
      }
    },
    zt = /#|\.prototype\./,
    qt = function (t, n) {
      var r = Ht[Wt(t)];
      return r == Xt || (r != Jt && ("function" == typeof n ? e(n) : !!n));
    },
    Wt = (qt.normalize = function (t) {
      return String(t).replace(zt, ".").toLowerCase();
    }),
    Ht = (qt.data = {}),
    Jt = (qt.NATIVE = "N"),
    Xt = (qt.POLYFILL = "P"),
    Kt = qt,
    Yt = kt.f,
    Zt = function (t, e) {
      var n,
        r,
        o,
        i,
        a,
        u = t.target,
        c = t.global,
        f = t.stat;
      if ((n = c ? p : f ? p[u] || I(u, {}) : (p[u] || {}).prototype))
        for (r in e) {
          if (
            ((i = e[r]),
            (o = t.noTargetGet ? (a = Yt(n, r)) && a.value : n[r]),
            !Kt(c ? r : u + (f ? "." : "#") + r, t.forced) && void 0 !== o)
          ) {
            if (typeof i == typeof o) continue;
            Bt(i, o);
          }
          (t.sham || (o && o.sham)) && O(i, "sham", !0), At(n, r, i, t);
        }
    },
    Qt = !e(function () {
      function t() {}
      return (
        (t.prototype.constructor = null),
        Object.getPrototypeOf(new t()) !== t.prototype
      );
    }),
    $t = it("IE_PROTO"),
    te = Object.prototype,
    ee = Qt
      ? Object.getPrototypeOf
      : function (t) {
          return (
            (t = Object(a(t))),
            U(t, $t)
              ? t[$t]
              : "function" == typeof t.constructor && t instanceof t.constructor
              ? t.constructor.prototype
              : t instanceof Object
              ? te
              : null
          );
        },
    ne = F("iterator"),
    re = !1;
  [].keys &&
    ("next" in (Ut = [].keys())
      ? (xt = ee(ee(Ut))) !== Object.prototype && (Nt = xt)
      : (re = !0)),
    null == Nt && (Nt = {}),
    U(Nt, ne) ||
      O(Nt, ne, function () {
        return this;
      });
  var oe = { IteratorPrototype: Nt, BUGGY_SAFARI_ITERATORS: re },
    ie = _.f,
    ae = F("toStringTag"),
    ue = function (t, e, n) {
      t &&
        !U((t = n ? t : t.prototype), ae) &&
        ie(t, ae, { configurable: !0, value: e });
    },
    ce = oe.IteratorPrototype,
    fe = function () {
      return this;
    },
    se = function (t, e, n) {
      var r = e + " Iterator";
      return (
        (t.prototype = st(ce, { next: w(1, n) })), ue(t, r, !1), (gt[r] = fe), t
      );
    },
    le =
      Object.setPrototypeOf ||
      ("__proto__" in {}
        ? (function () {
            var t,
              e = !1,
              n = {};
            try {
              (t = Object.getOwnPropertyDescriptor(
                Object.prototype,
                "__proto__"
              ).set).call(n, []),
                (e = n instanceof Array);
            } catch (t) {}
            return function (n, r) {
              return (
                E(n),
                (function (t) {
                  if (!g(t) && null !== t)
                    throw TypeError(
                      "Can't set " + String(t) + " as a prototype"
                    );
                })(r),
                e ? t.call(n, r) : (n.__proto__ = r),
                n
              );
            };
          })()
        : void 0),
    pe = oe.IteratorPrototype,
    he = oe.BUGGY_SAFARI_ITERATORS,
    ge = F("iterator"),
    ye = "keys",
    de = "values",
    ve = "entries",
    me = function () {
      return this;
    },
    Ee = "Array Iterator",
    be = Tt.set,
    Se = Tt.getterFor(Ee);
  !(function (t, e, n, r, o, i, a) {
    se(n, e, r);
    var u,
      c,
      f,
      s = function (t) {
        if (t === o && y) return y;
        if (!he && t in h) return h[t];
        switch (t) {
          case ye:
          case de:
          case ve:
            return function () {
              return new n(this, t);
            };
        }
        return function () {
          return new n(this);
        };
      },
      l = e + " Iterator",
      p = !1,
      h = t.prototype,
      g = h[ge] || h["@@iterator"] || (o && h[o]),
      y = (!he && g) || s(o),
      d = ("Array" == e && h.entries) || g;
    if (
      (d &&
        ((u = ee(d.call(new t()))),
        pe !== Object.prototype &&
          u.next &&
          (ee(u) !== pe &&
            (le ? le(u, pe) : "function" != typeof u[ge] && O(u, ge, me)),
          ue(u, l, !0))),
      o == de &&
        g &&
        g.name !== de &&
        ((p = !0),
        (y = function () {
          return g.call(this);
        })),
      h[ge] !== y && O(h, ge, y),
      (gt[e] = y),
      o)
    )
      if (((c = { values: s(de), keys: i ? y : s(ye), entries: s(ve) }), a))
        for (f in c) (he || p || !(f in h)) && At(h, f, c[f]);
      else Zt({ target: e, proto: !0, forced: he || p }, c);
  })(
    Array,
    "Array",
    function (t, e) {
      be(this, { type: Ee, target: u(t), index: 0, kind: e });
    },
    function () {
      var t = Se(this),
        e = t.target,
        n = t.kind,
        r = t.index++;
      return !e || r >= e.length
        ? ((t.target = void 0), { value: void 0, done: !0 })
        : "keys" == n
        ? { value: r, done: !1 }
        : "values" == n
        ? { value: e[r], done: !1 }
        : { value: [r, e[r]], done: !1 };
    },
    "values"
  );
  (gt.Arguments = gt.Array), ht("keys"), ht("values"), ht("entries");
  var _e = F("iterator"),
    we = !e(function () {
      var t = new URL("b?a=1&b=2&c=3", "http://a"),
        e = t.searchParams,
        n = "";
      return (
        (t.pathname = "c%20d"),
        e.forEach(function (t, r) {
          e.delete("b"), (n += r + t);
        }),
        !e.sort ||
          "http://a/c%20d?a=1&c=3" !== t.href ||
          "3" !== e.get("c") ||
          "a=1" !== String(new URLSearchParams("?a=1")) ||
          !e[_e] ||
          "a" !== new URL("https://a@b").username ||
          "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") ||
          "xn--e1aybc" !== new URL("http://Ñ‚ÐµÑÑ‚").host ||
          "#%D0%B1" !== new URL("http://a#Ð±").hash ||
          "a1c3" !== n ||
          "x" !== new URL("http://x", void 0).host
      );
    }),
    Oe = function (t, e, n) {
      if (!(t instanceof e))
        throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
      return t;
    },
    Ie = function (t, e, n) {
      if (
        ((function (t) {
          if ("function" != typeof t)
            throw TypeError(String(t) + " is not a function");
        })(t),
        void 0 === e)
      )
        return t;
      switch (n) {
        case 0:
          return function () {
            return t.call(e);
          };
        case 1:
          return function (n) {
            return t.call(e, n);
          };
        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };
        case 3:
          return function (n, r, o) {
            return t.call(e, n, r, o);
          };
      }
      return function () {
        return t.apply(e, arguments);
      };
    },
    Re = {};
  Re[F("toStringTag")] = "z";
  var Pe = "[object z]" === String(Re),
    Ne = F("toStringTag"),
    xe =
      "Arguments" ==
      r(
        (function () {
          return arguments;
        })()
      ),
    Ue = Pe
      ? r
      : function (t) {
          var e, n, o;
          return void 0 === t
            ? "Undefined"
            : null === t
            ? "Null"
            : "string" ==
              typeof (n = (function (t, e) {
                try {
                  return t[e];
                } catch (t) {}
              })((e = Object(t)), Ne))
            ? n
            : xe
            ? r(e)
            : "Object" == (o = r(e)) && "function" == typeof e.callee
            ? "Arguments"
            : o;
        },
    Te = F("iterator"),
    je = function (t) {
      if (null != t) return t[Te] || t["@@iterator"] || gt[Ue(t)];
    },
    Le = function (t) {
      var e = je(t);
      if ("function" != typeof e)
        throw TypeError(String(t) + " is not iterable");
      return E(e.call(t));
    },
    Ge = nt("fetch"),
    De = nt("Headers"),
    ke = F("iterator"),
    Ae = "URLSearchParams",
    Me = "URLSearchParamsIterator",
    Fe = Tt.set,
    Ce = Tt.getterFor(Ae),
    Ve = Tt.getterFor(Me),
    Be = /\+/g,
    ze = Array(4),
    qe = function (t) {
      return (
        ze[t - 1] || (ze[t - 1] = RegExp("((?:%[\\da-f]{2}){" + t + "})", "gi"))
      );
    },
    We = function (t) {
      try {
        return decodeURIComponent(t);
      } catch (e) {
        return t;
      }
    },
    He = function (t) {
      var e = t.replace(Be, " "),
        n = 4;
      try {
        return decodeURIComponent(e);
      } catch (t) {
        for (; n; ) e = e.replace(qe(n--), We);
        return e;
      }
    },
    Je = /[!'()~]|%20/g,
    Xe = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+",
    },
    Ke = function (t) {
      return Xe[t];
    },
    Ye = function (t) {
      return encodeURIComponent(t).replace(Je, Ke);
    },
    Ze = function (t, e) {
      if (e)
        for (var n, r, o = e.split("&"), i = 0; i < o.length; )
          (n = o[i++]).length &&
            ((r = n.split("=")),
            t.push({ key: He(r.shift()), value: He(r.join("=")) }));
    },
    Qe = function (t) {
      (this.entries.length = 0), Ze(this.entries, t);
    },
    $e = function (t, e) {
      if (t < e) throw TypeError("Not enough arguments");
    },
    tn = se(
      function (t, e) {
        Fe(this, { type: Me, iterator: Le(Ce(t).entries), kind: e });
      },
      "Iterator",
      function () {
        var t = Ve(this),
          e = t.kind,
          n = t.iterator.next(),
          r = n.value;
        return (
          n.done ||
            (n.value =
              "keys" === e
                ? r.key
                : "values" === e
                ? r.value
                : [r.key, r.value]),
          n
        );
      }
    ),
    en = function () {
      Oe(this, en, Ae);
      var t,
        e,
        n,
        r,
        o,
        i,
        a,
        u,
        c,
        f = arguments.length > 0 ? arguments[0] : void 0,
        s = this,
        l = [];
      if (
        (Fe(s, {
          type: Ae,
          entries: l,
          updateURL: function () {},
          updateSearchParams: Qe,
        }),
        void 0 !== f)
      )
        if (g(f))
          if ("function" == typeof (t = je(f)))
            for (n = (e = t.call(f)).next; !(r = n.call(e)).done; ) {
              if (
                (a = (i = (o = Le(E(r.value))).next).call(o)).done ||
                (u = i.call(o)).done ||
                !i.call(o).done
              )
                throw TypeError("Expected sequence with length 2");
              l.push({ key: a.value + "", value: u.value + "" });
            }
          else for (c in f) U(f, c) && l.push({ key: c, value: f[c] + "" });
        else
          Ze(
            l,
            "string" == typeof f
              ? "?" === f.charAt(0)
                ? f.slice(1)
                : f
              : f + ""
          );
    },
    nn = en.prototype;
  !(function (t, e, n) {
    for (var r in e) At(t, r, e[r], n);
  })(
    nn,
    {
      append: function (t, e) {
        $e(arguments.length, 2);
        var n = Ce(this);
        n.entries.push({ key: t + "", value: e + "" }), n.updateURL();
      },
      delete: function (t) {
        $e(arguments.length, 1);
        for (var e = Ce(this), n = e.entries, r = t + "", o = 0; o < n.length; )
          n[o].key === r ? n.splice(o, 1) : o++;
        e.updateURL();
      },
      get: function (t) {
        $e(arguments.length, 1);
        for (var e = Ce(this).entries, n = t + "", r = 0; r < e.length; r++)
          if (e[r].key === n) return e[r].value;
        return null;
      },
      getAll: function (t) {
        $e(arguments.length, 1);
        for (
          var e = Ce(this).entries, n = t + "", r = [], o = 0;
          o < e.length;
          o++
        )
          e[o].key === n && r.push(e[o].value);
        return r;
      },
      has: function (t) {
        $e(arguments.length, 1);
        for (var e = Ce(this).entries, n = t + "", r = 0; r < e.length; )
          if (e[r++].key === n) return !0;
        return !1;
      },
      set: function (t, e) {
        $e(arguments.length, 1);
        for (
          var n,
            r = Ce(this),
            o = r.entries,
            i = !1,
            a = t + "",
            u = e + "",
            c = 0;
          c < o.length;
          c++
        )
          (n = o[c]).key === a &&
            (i ? o.splice(c--, 1) : ((i = !0), (n.value = u)));
        i || o.push({ key: a, value: u }), r.updateURL();
      },
      sort: function () {
        var t,
          e,
          n,
          r = Ce(this),
          o = r.entries,
          i = o.slice();
        for (o.length = 0, n = 0; n < i.length; n++) {
          for (t = i[n], e = 0; e < n; e++)
            if (o[e].key > t.key) {
              o.splice(e, 0, t);
              break;
            }
          e === n && o.push(t);
        }
        r.updateURL();
      },
      forEach: function (t) {
        for (
          var e,
            n = Ce(this).entries,
            r = Ie(t, arguments.length > 1 ? arguments[1] : void 0, 3),
            o = 0;
          o < n.length;

        )
          r((e = n[o++]).value, e.key, this);
      },
      keys: function () {
        return new tn(this, "keys");
      },
      values: function () {
        return new tn(this, "values");
      },
      entries: function () {
        return new tn(this, "entries");
      },
    },
    { enumerable: !0 }
  ),
    At(nn, ke, nn.entries),
    At(
      nn,
      "toString",
      function () {
        for (var t, e = Ce(this).entries, n = [], r = 0; r < e.length; )
          (t = e[r++]), n.push(Ye(t.key) + "=" + Ye(t.value));
        return n.join("&");
      },
      { enumerable: !0 }
    ),
    ue(en, Ae),
    Zt({ global: !0, forced: !we }, { URLSearchParams: en }),
    we ||
      "function" != typeof Ge ||
      "function" != typeof De ||
      Zt(
        { global: !0, enumerable: !0, forced: !0 },
        {
          fetch: function (t) {
            var e,
              n,
              r,
              o = [t];
            return (
              arguments.length > 1 &&
                (g((e = arguments[1])) &&
                  ((n = e.body),
                  Ue(n) === Ae &&
                    ((r = e.headers ? new De(e.headers) : new De()).has(
                      "content-type"
                    ) ||
                      r.set(
                        "content-type",
                        "application/x-www-form-urlencoded;charset=UTF-8"
                      ),
                    (e = st(e, { body: w(0, String(n)), headers: w(0, r) })))),
                o.push(e)),
              Ge.apply(this, o)
            );
          },
        }
      );
  tt.URLSearchParams;
  void 0 === console.table &&
    (console.table = function () {
      for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
      console.log(t);
    });
  var rn = {
    NODE_ENV: "production1",
    BUILD:
      '{"date":"2022-10-14T23:40:43.137Z","branch":"N/A","hash":"dc37d6a6"}',
    GIVING_PAGE_URL_TEMPLATE:
      "https://pages.elevate.salesforce.org/embed/<%GP_ID%>",
    ORIGIN_REGEX: "pages\\.elevate\\.salesforce\\.org",
    EVENT_SIGNATURE: "sfdo-elevate-gp",
    DEBUG_URL_PARAM: "elevate-debug",
  };
  !(function (t) {
    var e,
      n = (function () {
        try {
          if (
            t.URLSearchParams &&
            "bar" === new t.URLSearchParams("foo=bar").get("foo")
          )
            return t.URLSearchParams;
        } catch (t) {}
        return null;
      })(),
      r = n && "a=1" === new n({ a: 1 }).toString(),
      o = n && "+" === new n("s=%2B").get("s"),
      i = !n || ((e = new n()).append("s", " &"), "s=+%26" === e.toString()),
      a = s.prototype,
      u = !(!t.Symbol || !t.Symbol.iterator);
    if (!(n && r && o && i)) {
      var c;
      (a.append = function (t, e) {
        y(this.__URLSearchParams__, t, e);
      }),
        (a.delete = function (t) {
          delete this.__URLSearchParams__[t];
        }),
        (a.get = function (t) {
          var e = this.__URLSearchParams__;
          return this.has(t) ? e[t][0] : null;
        }),
        (a.getAll = function (t) {
          var e = this.__URLSearchParams__;
          return this.has(t) ? e[t].slice(0) : [];
        }),
        (a.has = function (t) {
          return v(this.__URLSearchParams__, t);
        }),
        (a.set = function (t, e) {
          this.__URLSearchParams__[t] = ["" + e];
        }),
        (a.toString = function () {
          var t,
            e,
            n,
            r,
            o = this.__URLSearchParams__,
            i = [];
          for (e in o)
            for (n = l(e), t = 0, r = o[e]; t < r.length; t++)
              i.push(n + "=" + l(r[t]));
          return i.join("&");
        }),
        !!o && n && !r && t.Proxy
          ? ((c = new Proxy(n, {
              construct: function (t, e) {
                return new t(new s(e[0]).toString());
              },
            })).toString = Function.prototype.toString.bind(s))
          : (c = s),
        Object.defineProperty(t, "URLSearchParams", { value: c });
      var f = t.URLSearchParams.prototype;
      (f.polyfill = !0),
        (f.forEach =
          f.forEach ||
          function (t, e) {
            var n = g(this.toString());
            Object.getOwnPropertyNames(n).forEach(function (r) {
              n[r].forEach(function (n) {
                t.call(e, n, r, this);
              }, this);
            }, this);
          }),
        (f.sort =
          f.sort ||
          function () {
            var t,
              e,
              n,
              r = g(this.toString()),
              o = [];
            for (t in r) o.push(t);
            for (o.sort(), e = 0; e < o.length; e++) this.delete(o[e]);
            for (e = 0; e < o.length; e++) {
              var i = o[e],
                a = r[i];
              for (n = 0; n < a.length; n++) this.append(i, a[n]);
            }
          }),
        (f.keys =
          f.keys ||
          function () {
            var t = [];
            return (
              this.forEach(function (e, n) {
                t.push(n);
              }),
              h(t)
            );
          }),
        (f.values =
          f.values ||
          function () {
            var t = [];
            return (
              this.forEach(function (e) {
                t.push(e);
              }),
              h(t)
            );
          }),
        (f.entries =
          f.entries ||
          function () {
            var t = [];
            return (
              this.forEach(function (e, n) {
                t.push([n, e]);
              }),
              h(t)
            );
          }),
        u && (f[t.Symbol.iterator] = f[t.Symbol.iterator] || f.entries);
    }
    function s(t) {
      ((t = t || "") instanceof URLSearchParams || t instanceof s) &&
        (t = t.toString()),
        (this.__URLSearchParams__ = g(t));
    }
    function l(t) {
      var e = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0",
      };
      return encodeURIComponent(t).replace(/[!'\(\)~]|%20|%00/g, function (t) {
        return e[t];
      });
    }
    function p(t) {
      return t
        .replace(/[ +]/g, "%20")
        .replace(/(%[a-f0-9]{2})+/gi, function (t) {
          return decodeURIComponent(t);
        });
    }
    function h(e) {
      var n = {
        next: function () {
          var t = e.shift();
          return { done: void 0 === t, value: t };
        },
      };
      return (
        u &&
          (n[t.Symbol.iterator] = function () {
            return n;
          }),
        n
      );
    }
    function g(t) {
      var e = {};
      if ("object" == typeof t)
        if (d(t))
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            if (!d(r) || 2 !== r.length)
              throw new TypeError(
                "Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements"
              );
            y(e, r[0], r[1]);
          }
        else for (var o in t) t.hasOwnProperty(o) && y(e, o, t[o]);
      else {
        0 === t.indexOf("?") && (t = t.slice(1));
        for (var i = t.split("&"), a = 0; a < i.length; a++) {
          var u = i[a],
            c = u.indexOf("=");
          -1 < c
            ? y(e, p(u.slice(0, c)), p(u.slice(c + 1)))
            : u && y(e, p(u), "");
        }
      }
      return e;
    }
    function y(t, e, n) {
      var r =
        "string" == typeof n
          ? n
          : null != n && "function" == typeof n.toString
          ? n.toString()
          : JSON.stringify(n);
      v(t, e) ? t[e].push(r) : (t[e] = [r]);
    }
    function d(t) {
      return !!t && "[object Array]" === Object.prototype.toString.call(t);
    }
    function v(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }
  })(void 0 !== c ? c : "undefined" != typeof window ? window : c);
  var on,
    an,
    un = new URLSearchParams(window.location.search),
    cn = function (t) {
      return un.get(t);
    },
    fn = "Elevate Donation Widget:",
    sn = 0,
    ln = function (t) {
      var e = "";
      return (e += "[" + t + "]"), 0 === sn && (e += " " + fn), e;
    },
    pn = function () {
      for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
      console.error.apply(console, t([ln("ERROR")], e));
    },
    hn = function (t) {
      "test" !== rn.NODE_ENV && (console.group(fn + " " + t), sn++);
    },
    gn = function () {
      "test" !== rn.NODE_ENV && (console.groupEnd(), (sn = Math.max(--sn, 0)));
    },
    yn = function () {
      for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
      "test" !== rn.NODE_ENV && console.log.apply(console, t([ln("INFO")], e));
    },
    dn = function () {
      for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
      ("develop" !== rn.NODE_ENV && "true" !== cn(rn.DEBUG_URL_PARAM)) ||
        console.log.apply(console, t([ln("DEBUG")], e));
    },
    vn = function () {
      for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
      console.error.apply(console, t([ln("ERROR")], e));
    },
    mn = function (t) {
      "test" !== rn.NODE_ENV && console.table(t);
    },
    En = rn.BUILD;
  try {
    on = JSON.parse(En);
  } catch (pn) {
    vn("Could not parse build info", { buildString: En }), vn(pn), (on = {});
  }
  hn("Build Info:"),
    mn(on),
    gn(),
    (function (t) {
      (t.ELEMENT_NOT_FOUND = "page element not found"),
        (t.IFRAME_NOT_FOUND_RESIZE =
          "iframe was not found during resize event"),
        (t.EVENT_MISSING_HEIGHT = "height was not passed to event"),
        (t.NO_EVENT_LISTENER = "browser does not support event listener"),
        (t.MISSING_REQUIRED_CONFIG = "missing a required build config"),
        (t.MISSING_USER_CONFIG_EL_ID = "missing elementID config variable"),
        (t.MISSING_USER_CONFIG_GP_ID = "missing givingPageId config variable"),
        (t.INSECURE_PAGE = "page is not secure, aborting"),
        (t.REJECTED_ORIGIN = "origin for event not approved");
    })(an || (an = {}));
  return function (t) {
    var e = this;
    if (
      ((this.mount = function () {
        if ((dn("mount start"), !window.addEventListener))
          return vn(an.NO_EVENT_LISTENER), !1;
        if ("https:" !== window.location.protocol && "develop" !== rn.NODE_ENV)
          return vn(an.INSECURE_PAGE, { href: window.location.href }), !1;
        var t = document.getElementById(e.configs.elementId);
        if (!t) return vn(an.ELEMENT_NOT_FOUND, { el: t }), !1;
        var n = document.createElement("iframe");
        return (
          (n.id = e.frameID),
          (n.src =
            ("" + rn.GIVING_PAGE_URL_TEMPLATE).replace(
              "<%GP_ID%>",
              e.configs.givingPageId
            ) + (un.toString().length > 1 ? "?" + un.toString() : "")),
          (n.width = "100%"),
          (n.height = "0"),
          (n.style.border = "0"),
          (n.style.backgroundColor = "transparent"),
          t.parentNode.replaceChild(n, t),
          window.addEventListener("message", e.handleMessage.bind(e)),
          dn("finished mounting", { el: t, frame: n }),
          !0
        );
      }),
      (this.handleMessage = function (t) {
        dn("received message", { event: t });
        var n = t.data,
          r = n.signature,
          o = n.height,
          i = n.redirectUrl;
        if (r === rn.EVENT_SIGNATURE)
          if (t.origin.match(new RegExp(rn.ORIGIN_REGEX))) {
            if (i) return dn("got redirect url", i), void (window.location = i);
            o || vn(an.EVENT_MISSING_HEIGHT, { data: t.data });
            var a = e.frameID,
              u = document.getElementById(a);
            u
              ? ((u.height = o),
                dn("set iframe height", { height: o, el: u, frameID: a }))
              : vn(an.IFRAME_NOT_FOUND_RESIZE, { el: u });
          } else {
            vn(an.REJECTED_ORIGIN, { event: t, regex: rn.ORIGIN_REGEX });
            var c = document.getElementById(e.frameID);
            c && (c.remove(), dn("removed iframe", { el: c }));
          }
        else
          dn("ignoring message with unknown signature", {
            signature: r,
            event: t,
          });
      }),
      !t.elementId)
    )
      throw new Error(an.MISSING_USER_CONFIG_EL_ID);
    if (!t.givingPageId) throw new Error(an.MISSING_USER_CONFIG_GP_ID);
    (this.configs = t),
      (this.frameID = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (t) {
          var e = (16 * Math.random()) | 0;
          return ("x" == t ? e : (3 & e) | 8).toString(16);
        }
      ));
    var n = (function (t, e) {
      var n = {};
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) &&
          e.indexOf(r) < 0 &&
          (n[r] = t[r]);
      if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (r = Object.getOwnPropertySymbols(t); o < r.length; o++)
          e.indexOf(r[o]) < 0 &&
            Object.prototype.propertyIsEnumerable.call(t, r[o]) &&
            (n[r[o]] = t[r[o]]);
      }
      return n;
    })(rn, ["BUILD"]);
    yn("Initialized SDK", { env: n, configs: this.configs });
  };
});
//# sourceMappingURL=sdk.js.map



// WEBPACK FOOTER //
// ./assets/js/salesforce/elevate.js